const SIGN_IN_R = '@auth/SIGN_IN_R'
const SIGN_IN_S = '@auth/SIGN_IN_S'
const SIGN_IN_E = '@auth/SIGN_IN_E'
const SIGN_IN_V = '@auth/SIGN_IN_V'
const SIGN_OUT = '@auth/SIGN_OUT'

export { SIGN_IN_R, SIGN_IN_S, SIGN_IN_E, SIGN_IN_V, SIGN_OUT }
